import React from "react"
import styled from "styled-components"
import { Box } from "theme-ui"
import { Heading } from "./typography"
import RichContentTextBlock from "./richContentTextBlock"
import customBorder from "../images/custom-border.svg"
import { LinkButton, ExternalLinkButton } from "./button"
import { getPagePath } from "./pathUtils"

const TextBlock = ({ title, text, highlight, fullwidth, link }) => (
  <>
    {fullwidth ? (
      <Wrapper>
        <Text title={title} text={text} highlight={highlight} link={link} />
      </Wrapper>
    ) : (
      <Text title={title} text={text} highlight={highlight} link={link} />
    )}
  </>
)

const TextBlockLink = ({ link }) => {
  if (!link) return null

  if (link.__typename === "DatoCmsPageLink" && link.page) {
    return (
      <Box>
        <LinkButton to={getPagePath(link.page, link.locale)}>
          {link.name}
        </LinkButton>
      </Box>
    )
  }

  if (link.__typename === "DatoCmsLink" && link.url) {
    return (
      <Box>
        <ExternalLinkButton
          href={link.url}
          target={link.openInNewWindow ? "_blank" : undefined}
          rel={link.openInNewWindow ? "noopener noreferrer" : undefined}
        >
          {link.anchor}
        </ExternalLinkButton>
      </Box>
    )
  }

  return null
}

const Text = ({ title, text, highlight, link }) => (
  <Box
    sx={{ py: 5, background: highlight ? "primary" : "light" }}
    highlight={highlight}
  >
    <StyledBox>
      {title && <Heading>{title}</Heading>}
      <RichContentTextBlock html={text} />
      <TextBlockLink link={link} />
    </StyledBox>
  </Box>
)

const Wrapper = styled.div``

const StyledBox = styled.div`
  padding-top: 2rem;
  background-image: url(${customBorder});
  background-repeat: no-repeat;
  & > * {
    margin-bottom: 2rem;
    &:last-child {
      margin-bottom: 0;
    }
  }
`

export default TextBlock
